import { notification } from 'antd'
import axios from './axiosInstance'
// import Cookies from 'js-cookie'
import constants from '../constants'
import { handleErrors, definedErrorCodes, isAuthErrorCode } from '../helpers'

export async function login(email, password) {
  const data = {
    email: email.trim(),
    password: password.trim(),
  }
  return axios
    .post(`${constants.customerDomain}login`, data)
    .then(res => {
      localStorage.setItem('ccBearerToken', res.data.data.token)
      localStorage.setItem('meInfo', JSON.stringify(res.data.data))

      if (
        res.data.data !== undefined &&
        res.data.data.name !== undefined &&
        res.data.data.email !== undefined
      ) {
        const userDataObj = {
          user: { id: res.data.data.id, name: res.data.data.name, email: res.data.data.email },
        }

        localStorage.setItem('userData', JSON.stringify(userDataObj))
      }
      return res.data
    })
    .catch(error => {
      let errorObj = {
        error: true,
        errDescription: error.response.data.error.message,
        errMessage: handleErrors(''),
      }

      if (
        error.response.data.error.code !== undefined &&
        definedErrorCodes(error.response.data.error.code)
      ) {
        errorObj = {
          errcode: error.response.data.error.code,
          error: true,
          errDescription: handleErrors(error.response.data.error.code, 'login').description,
          errMessage: handleErrors(error.response.data.error.code, 'login').message,
        }
      }
      return errorObj
    })
}

export async function loginOTP(email, password, otp) {
  const data = {
    email: email.trim(),
    password: password.trim(),
    otp,
  }
  return axios
    .post(`${constants.customerDomain}login`, data)
    .then(res => {
      localStorage.setItem('ccBearerToken', res.data.data.token)
      localStorage.setItem('meInfo', JSON.stringify(res.data.data))

      if (
        res.data.data !== undefined &&
        res.data.data.name !== undefined &&
        res.data.data.email !== undefined
      ) {
        const userDataObj = {
          user: { id: res.data.data.id, name: res.data.data.name, email: res.data.data.email },
        }

        localStorage.setItem('userData', JSON.stringify(userDataObj))
      }
      return res.data
    })
    .catch(error => {
      let errorObj = {
        error: true,
        errDescription: error.response.data.error.message,
        errMessage: handleErrors(''),
      }

      if (
        error.response.data.error.code !== undefined &&
        definedErrorCodes(error.response.data.error.code)
      ) {
        errorObj = {
          errcode: error.response.data.error.code,
          error: true,
          errDescription: handleErrors(error.response.data.error.code, 'login').description,
          errMessage: handleErrors(error.response.data.error.code, 'login').message,
        }
      }
      return errorObj
    })
}

export async function signup(data) {
  return axios
    .post(`${constants.customerDomain}register`, data)
    .then(res => {
      const ccPreviewBuilderId = localStorage.getItem('ccPreviewBuilderId')
      localStorage.clear()
      if (ccPreviewBuilderId) localStorage.setItem('ccPreviewBuilderId', ccPreviewBuilderId)
      localStorage.setItem('ccBearerToken', res.data.data.token)
      localStorage.setItem('meInfo', JSON.stringify(res.data.data))
      if (
        res.data.data !== undefined &&
        res.data.data.name !== undefined &&
        res.data.data.email !== undefined
      ) {
        const userDataObj = {
          user: { id: res.data.data.id, name: res.data.data.name, email: res.data.data.email },
        }

        localStorage.setItem('userData', JSON.stringify(userDataObj))
      }
      return res.data
    })
    .catch(error => {
      let errorObj = {
        error: true,
        errDescription: error.response.data.error.message,
        errMessage: handleErrors(''),
      }

      if (
        error.response.data.error.code !== undefined &&
        definedErrorCodes(error.response.data.error.code)
      ) {
        errorObj = {
          error: true,
          errDescription: handleErrors(error.response.data.error.code, 'signup').description,
          errMessage: handleErrors(error.response.data.error.code, 'signup').message,
        }
      } else if (
        error.response.data.error.details !== undefined &&
        error.response.data.error.details.email !== undefined
      ) {
        const { email: emailErr } = error.response.data.error.details

        errorObj = {
          error: true,
          errDescription: emailErr,
          errMessage: 'Account Email',
        }
      } else if (
        error.response.data.error.details !== undefined &&
        error.response.data.error.details.contactNumber !== undefined
      ) {
        const { contactNumber: contactNumberErr } = error.response.data.error.details

        errorObj = {
          error: true,
          errDescription: contactNumberErr,
          errMessage: 'Error signing up',
        }
      } else {
        errorObj = {
          error: true,
          errDescription: error.response.data.error.message,
          errMessage: 'Warning',
        }
      }

      return errorObj
    })
}

export async function currentAccount() {
  const ccBearerToken = localStorage.getItem('ccBearerToken')

  return axios
    .get(`${constants.customerDomain}me`, {
      headers: { Authorization: `Bearer ${ccBearerToken}` },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      // let errorMsgs = handleErrors('')
      let errorObj = {
        error: true,
        errDescription: error.response.data.error.message,
        errMessage: handleErrors(''),
      }
      if (error.response && error.response.data.error.code === 'AUTH_ERR_INVALID_CREDENTIALS') {
        errorObj = {
          error: true,
          errDescription: error.response.data.error.message,
          errMessage: 'Warning',
        }
      } else if (
        error.response &&
        error.response.data.error.code !== undefined &&
        definedErrorCodes(error.response.data.error.code)
      ) {
        if (error.response.data?.error?.message?.includes('relogin')) {
          errorObj = {}
        } else {
          errorObj = {
            error: true,
            errDescription: handleErrors(error.response.data.error.code, 'auth').description,
            errMessage: handleErrors(error.response.data.error.code, 'auth').message,
          }
        }
        localStorage.clear()
      } else {
        errorObj = {
          error: true,
          errDescription: error.response.data.error.message,
          errMessage: handleErrors(error.response.data.error.code, 'auth').message,
        }
      }
      return errorObj
    })
}
export async function getAccountFromToken(ccBearerToken) {
  return axios
    .get(`${constants.customerDomain}me`, {
      headers: { Authorization: `Bearer ${ccBearerToken}` },
    })
    .then(res => {
      localStorage.setItem('ccBearerToken', ccBearerToken)
      localStorage.setItem('meInfo', JSON.stringify(res.data.data))
      if (
        res.data.data !== undefined &&
        res.data.data.name !== undefined &&
        res.data.data.email !== undefined
      ) {
        const userDataObj = {
          user: { id: res.data.data.id, name: res.data.data.name, email: res.data.data.email },
        }

        localStorage.setItem('userData', JSON.stringify(userDataObj))
      }
      return res.data
    })
    .catch(error => {
      let errorMsgs = handleErrors('')
      if (
        error.response &&
        error.response.data.error.code !== undefined &&
        definedErrorCodes(error.response.data.error.code)
      ) {
        errorMsgs = handleErrors(error.response.data.error.code)
        notification.warning({
          message: errorMsgs.message,
          description: errorMsgs.description,
        })
      } else if (
        error.response &&
        error.response.data.error.code === 'AUTH_ERR_INVALID_CREDENTIALS'
      ) {
        notification.warning({
          message: 'Warning',
          description: error.response.data.error.message,
        })
      }
    })
}

export async function updateProfile(post) {
  const ccBearerToken = localStorage.getItem('ccBearerToken')

  return axios
    .put(`${constants.customerDomain}me`, post, {
      headers: { Authorization: `Bearer ${ccBearerToken}` },
    })
    .then(res => {
      if (
        res.data.data !== undefined &&
        res.data.data.name !== undefined &&
        res.data.data.email !== undefined
      ) {
        const userDataObj = {
          user: { id: res.data.data.id, name: res.data.data.name, email: res.data.data.email },
        }

        localStorage.setItem('userData', JSON.stringify(userDataObj))
      }
      return res.data
    })
    .catch(error => {
      let errorObj = {
        error: true,
        errDescription: error.response.data.error.message,
        errMessage: handleErrors(''),
      }
      // let errDescription = error.response.data.error.message
      // let errorMsgs = handleErrors('')

      if (
        error.response &&
        error.response.data.error.code !== undefined &&
        definedErrorCodes(error.response.data.error.code)
      ) {
        // errMessage = handleErrors(error.response.data.error.code, 'updateProfile')
        // notification.warning({
        //   message: errorMsgs.message,
        //   description: errorMsgs.description,
        // })
        errorObj = {
          error: true,
          errDescription: handleErrors(error.response.data.error.code, 'updateProfile').message,
          errMessage: handleErrors(error.response.data.error.code, 'updateProfile').description,
        }
      } else if (
        error.response.data.error.details !== undefined &&
        error.response.data.error.details.contactNumber !== undefined
      ) {
        const { contactNumber: contactNumberErr } = error.response.data.error.details
        // errDescription = contactNumberErr
        // notification.error({
        //   message: 'Account Contact number',
        //   description: errDescription,
        // })
        errorObj = {
          error: true,
          errDescription: contactNumberErr,
          errMessage: 'Account Contact number',
        }
      } else if (
        error.response.data.error.details !== undefined &&
        error.response.data.error.details.email !== undefined
      ) {
        const { email: emailErr } = error.response.data.error.details
        // errDescription = emailErr
        // notification.error({
        //   message: 'Account Email',
        //   description: errDescription,
        // })
        errorObj = {
          error: true,
          errDescription: emailErr,
          errMessage: 'Account Email',
        }
      } else {
        // notification.warning({
        //   message: 'Warning',
        //   description: errDescription,
        // })
        errorObj = {
          error: true,
          errDescription: error.response.data.error.message,
          errMessage: 'Warningssssss',
        }
      }

      return errorObj
    })
}

export async function sendResetPasswordEmail(email) {
  const data = {
    email: email.trim(),
  }
  return axios
    .post(`${constants.customerDomain}reset/password`, data)
    .then(res => {
      return res.data
    })
    .catch(error => {
      let errorObj = {
        error: true,
        errDescription: error.response.data.error.message,
        errMessage: handleErrors(''),
      }

      if (
        error.response &&
        error.response.data.error.code !== undefined &&
        definedErrorCodes(error.response.data.error.code)
      ) {
        if (
          !isAuthErrorCode(error.response.data.error.code) ||
          error.response.data.error.code === 'ERR_TOO_MANY_DIRECT_REQUESTS'
        ) {
          errorObj = {
            error: true,
            errDescription: handleErrors(error.response.data.error.code, 'sendResetPasswordEmail')
              .description,
            errMessage: handleErrors(error.response.data.error.code, 'sendResetPasswordEmail')
              .message,
          }
        }
      } else if (error.response.data.error.details.email !== undefined) {
        errorObj = {
          error: true,
          errDescription:
            'The mentioned email is not associated with any account. Please try signing up.',
          errMessage: 'Email id not found',
        }
      }
      return errorObj
    })
}

export async function resetPassword(password, resetPasswordToken) {
  const data = {
    password: password.trim(),
  }
  return axios
    .post(`${constants.customerDomain}reset/password/${resetPasswordToken}`, data)
    .then(res => {
      return res.data
    })
    .catch(error => {
      const errorObj = {
        errMessage: 'Error processing request',
        errDescription: error.response.data.error.message,
        error: true,
      }
      if (error.response.data.error.code === 'ERR_CODE_NOT_FOUND')
        errorObj.errDescription =
          'The verification code has expired or is invalid, please try requesting a new one.'

      return errorObj
    })
}

export async function verifyEmail(verifyEmailToken) {
  return axios
    .post(`${constants.customerDomain}verify/email/${verifyEmailToken}`, {})
    .then(res => {
      return res.data
    })
    .catch(error => {
      // const errDescription = error.response.data.error.message
      // const errMessage = 'Error processing request'

      // notification.error({
      //   message: errMessage,
      //   description: errDescription,
      // })

      return error
    })
}

export async function oAuthGoogle(token, googleId) {
  let response = { success: false }
  return axios
    .get(`https://www.googleapis.com/oauth2/v3/tokeninfo?id_token=${token}`)
    .then(res => {
      if (res.data.email !== undefined)
        response = {
          data: {
            email: res.data.email,
            name: res.data.name,
            password: `${googleId}.${constants.uniqHashString}`,
            googleOauth: true,
          },
          success: true,
        }
      return response
    })
    .catch(error => {
      response.error = error
      return response
    })
}

export async function getBillingData() {
  const ccBearerToken = localStorage.getItem('ccBearerToken')

  return axios
    .post(
      `${constants.customerDomain}me/billing`,
      {},
      {
        headers: { Authorization: `Bearer ${ccBearerToken}` },
      },
    )
    .then(res => {
      return res.data
    })
    .catch(error => {
      let errorMsgs = handleErrors('')
      if (
        error.response &&
        error.response.data.error.code !== undefined &&
        definedErrorCodes(error.response.data.error.code)
      ) {
        errorMsgs = handleErrors(error.response.data.error.code, 'getBillingData')
        if (
          !isAuthErrorCode(error.response.data.error.code) ||
          error.response.data.error.code === 'AUTH_ERR_TOKEN_BLACKLISTED'
        ) {
          notification.warning({
            message: errorMsgs.message,
            description: errorMsgs.description,
          })
        }
      } else {
        notification.warning({
          message: 'Warning',
          description: error.response.data.error.message,
        })
      }

      return error.response.data
    })
}

export async function manualOutreach(post) {
  const ccBearerToken = localStorage.getItem('ccBearerToken')

  return axios
    .put(`${constants.customerDomain}me/manual-outreach`, post, {
      headers: { Authorization: `Bearer ${ccBearerToken}` },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      let errorMsgs = handleErrors('')
      if (
        error.response &&
        error.response.data.error.code !== undefined &&
        definedErrorCodes(error.response.data.error.code)
      ) {
        errorMsgs = handleErrors(error.response.data.error.code, 'manualOutreach')
        notification.warning({
          message: errorMsgs.message,
          description: errorMsgs.description,
        })
      } else {
        notification.warning({
          message: 'Warning',
          description: error.response.data.error.message,
        })
      }

      return error.response.data
    })
}

export async function acceptCollboratorInvitation(collboratorInvitationToken) {
  return axios
    .post(`${constants.customerDomain}collaborate/app/${collboratorInvitationToken}`, {})
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error
    })
}

export async function registerEmail(data) {
  return axios
    .post(`${constants.customerDomain}register/email`, data)
    .then(res => {
      return res.data
    })
    .catch(error => {
      let errorObj = {
        error: true,
        errDescription: error.response.data.error.message,
        errMessage: handleErrors(''),
      }

      if (
        error.response.data.error.code !== undefined &&
        definedErrorCodes(error.response.data.error.code)
      ) {
        errorObj = {
          error: true,
          errDescription: handleErrors(error.response.data.error.code, 'signup').description,
          errMessage: handleErrors(error.response.data.error.code, 'signup').message,
        }
      } else {
        errorObj = {
          error: true,
          errDescription: error.response.data.error.message,
          errMessage: 'Warning',
          errCode: error.response.data.error.code,
        }
      }

      return errorObj
    })
}

export async function getCustomerContext(data) {
  return axios
    .post(`${constants.customerDomain}customer/context`, data)
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function loginWithProvider(provider) {
  try {
    const res = await axios.get(`${constants.customerDomain}/oauth/${provider}/redirect_url`, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Cache-Control': 'no-cache',
        'X-Requested-With': 'XMLHttpRequest',
      },
      withCredentials: false, // equivalent to credentials: 'omit'
    })

    const { url } = res.data.data
    if (!url) throw new Error('No redirect URL received')
    window.location.href = url
  } catch (err) {
    console.error('Failed to get redirect URL:', err)
    throw err
  }
}

export async function handleOAuthCallback(dispatch) {
  const urlParams = new URLSearchParams(window.location.search)
  const code = urlParams.get('code')
  const scope = urlParams.get('scope')
  const error = urlParams.get('error')

  if (error) {
    return { status: `OAuth Error: ${error}`, success: false }
  }

  if (!code) {
    return { status: 'No code found in URL', success: false }
  }

  const detectedProvider = scope === null ? 'github' : 'google'

  try {
    const res = await axios.get(
      `${constants.customerDomain}/oauth/${detectedProvider}/callback_data`,
      {
        params: { code }, // axios way of adding query params
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        withCredentials: false,
      },
    )

    const token = res.data.data?.token

    localStorage.setItem('ccBearerToken', res.data.data.token)
    localStorage.setItem('meInfo', JSON.stringify(res?.data?.data))

    if (token) {
      dispatch({
        type: 'user/LOGIN_TOKEN',
        payload: { token, new: res?.data?.data?.new },
      })
      return { status: 'Login successful! Redirecting...', success: true }
    }

    return { status: 'No token received', success: false }
  } catch (err) {
    console.error('OAuth callback error:', err)
    throw err
  }
}
